/**
 *
 * Asynchronously loads the component for HomeTemplate
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TermsTemplate = lazyLoad(
  () => import('app/modules/Parameters/TermsTemplate/index'),
  (module) => module.TermsTemplate
);
